const player = {
  avPlayerScriptUrl: 'https://avplayer.sportradar.com/agamo/latest/avvpl-player.js',
  avPlayerStyleUrl: 'https://avplayer.sportradar.com/agamo/latest/avvpl-player.css',
  debugPlayerUrl: 'https://avplayer.sportradar.com/avvpl-debug-player/?streamUrl=:url&type=:format&useDefaults=1',
};

export default player;
